import api from '../api/axiosInstance';
import { getAuthToken } from '../api/authToken';

/**
 * Authenticated GET for permission loading.
 * Uses axiosInstance so 401 triggers central cookie-based refresh and retry.
 */
export const authGet = (url, explicitToken) => {
  const token = getAuthToken(explicitToken);
  if (!token) {
    return Promise.reject(new Error('[Auth] No auth token available for request'));
  }

  return api.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export { getAuthToken } from '../api/authToken';
